import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GARMENTS = ["hoodie", "tee", "crewneck", "cap"];

const inputCls =
    "mt-1 w-full bg-transparent border border-zinc-800 px-3 py-2 text-sm focus:outline-none focus:border-signal transition-colors duration-300";
const labelCls = "text-[10px] tracking-[0.2em] uppercase text-zinc-500";

export const ProductsTab = ({ token }) => {
    const [products, setProducts] = useState([]);
    const [msg, setMsg] = useState("");
    const auth = { headers: { Authorization: `Bearer ${token}` } };

    const load = useCallback(() => {
        axios.get(`${API}/site`).then((r) => setProducts(r.data.products || [])).catch(() => {});
    }, []);
    useEffect(() => { load(); }, [load]);

    const update = (i, k, v) => setProducts((ps) => ps.map((p, j) => (j === i ? { ...p, [k]: v } : p)));
    const flash = (t) => {
        setMsg(t);
        setTimeout(() => setMsg(""), 2500);
    };

    const save = async (p) => {
        try {
            await axios.put(`${API}/admin/products/${p.id}`, p, auth);
            flash("Saved — live on the site");
        } catch {
            flash("Save failed");
        }
    };
    const remove = async (p) => {
        try {
            await axios.delete(`${API}/admin/products/${p.id}`, auth);
            load();
        } catch {
            flash("Delete failed");
        }
    };
    const add = async () => {
        try {
            await axios.post(
                `${API}/admin/products`,
                {
                    number: String(products.length + 1).padStart(3, "0"),
                    name: "New Piece",
                    detail: "Describe the fabric",
                    price: "€0",
                    garment: "tee",
                    order: products.length + 1,
                },
                auth
            );
            load();
        } catch {
            flash("Add failed");
        }
    };

    return (
        <div data-testid="admin-products-tab">
            <div className="flex items-center justify-between mb-8">
                <h2 className="font-display font-semibold uppercase tracking-tight text-2xl">Product Catalog</h2>
                <button
                    onClick={add}
                    data-testid="admin-add-product-button"
                    className="px-5 py-2 border border-zinc-700 text-[10px] tracking-[0.25em] uppercase hover:border-signal hover:text-signal transition-colors duration-300"
                >
                    + Add piece
                </button>
            </div>
            {msg && (
                <p className="text-signal text-xs tracking-[0.2em] uppercase mb-6" data-testid="admin-products-msg">
                    {msg}
                </p>
            )}
            <div className="space-y-6">
                {products.map((p, i) => (
                    <div key={p.id} className="border border-zinc-800 p-5 grid grid-cols-2 md:grid-cols-6 gap-4 items-end" data-testid={`admin-product-row-${i}`}>
                        <label className="block">
                            <span className={labelCls}>Number</span>
                            <input className={inputCls} value={p.number} onChange={(e) => update(i, "number", e.target.value)} data-testid={`admin-product-number-${i}`} />
                        </label>
                        <label className="block col-span-2">
                            <span className={labelCls}>Name</span>
                            <input className={inputCls} value={p.name} onChange={(e) => update(i, "name", e.target.value)} data-testid={`admin-product-name-${i}`} />
                        </label>
                        <label className="block col-span-2">
                            <span className={labelCls}>Detail</span>
                            <input className={inputCls} value={p.detail} onChange={(e) => update(i, "detail", e.target.value)} data-testid={`admin-product-detail-${i}`} />
                        </label>
                        <label className="block">
                            <span className={labelCls}>Price</span>
                            <input className={inputCls} value={p.price} onChange={(e) => update(i, "price", e.target.value)} data-testid={`admin-product-price-${i}`} />
                        </label>
                        <label className="block col-span-2">
                            <span className={labelCls}>Garment</span>
                            <select className={`${inputCls} bg-void`} value={p.garment} onChange={(e) => update(i, "garment", e.target.value)} data-testid={`admin-product-garment-${i}`}>
                                {GARMENTS.map((g) => (
                                    <option key={g} value={g}>{g}</option>
                                ))}
                            </select>
                        </label>
                        <label className="block col-span-2">
                            <span className={labelCls}>Image URL (optional — replaces drawing)</span>
                            <input className={inputCls} value={p.image_url || ""} onChange={(e) => update(i, "image_url", e.target.value)} placeholder="https://…" data-testid={`admin-product-image-${i}`} />
                        </label>
                        <label className="block">
                            <span className={labelCls}>Order</span>
                            <input type="number" className={inputCls} value={p.order ?? i + 1} onChange={(e) => update(i, "order", Number(e.target.value))} data-testid={`admin-product-order-${i}`} />
                        </label>
                        <div className="col-span-2 md:col-span-1 flex gap-2">
                            <button onClick={() => save(p)} data-testid={`admin-product-save-${i}`} className="flex-1 bg-white text-void px-4 py-2 text-[10px] tracking-[0.25em] uppercase hover:bg-signal hover:text-white transition-colors duration-300">
                                Save
                            </button>
                            <button onClick={() => remove(p)} data-testid={`admin-product-delete-${i}`} className="px-4 py-2 border border-zinc-700 text-[10px] tracking-[0.25em] uppercase text-zinc-400 hover:border-signal hover:text-signal transition-colors duration-300">
                                Del
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
